import React from 'react';
import enhance from './Campaign.enhancer';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { Grid } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Button from '@material-ui/core/Button';
import { campaignStatuses, contentTypes } from '../../constants';
import moment from 'moment';
import Dialog from '@material-ui/core/Dialog';
import { getCountryValueFromKey } from '../../helpers/countryHelper';
import HpTooltip from '../../components/shared/components/hpTooltip';
import CampaignDetails from './CampaignDetails';
import CampaignNavBar from './CampaignNavBar';
import DiscoverInfluencers from '../company/discover-influencers/DiscoverInfluncers';
import ReviewProposals from './review-campaigns/ReviewProposals';
import CampaignDeals from './deals/CampaignDeals';
import { dealStatuses } from '../../constants';
import SwipeableViews from 'react-swipeable-views';
import { virtualize, bindKeyboard } from 'react-swipeable-views-utils';
import DealForm from '../deals/new-deal/DealForm';

const VirtualizeSwipeableViews = bindKeyboard(virtualize(SwipeableViews));

class Campaign extends React.Component {
  constructor() {
    super();

    this.initialState = {
      campaignNotFound: false,
      index: 0,
      influencerViewIndex: 0,
      value: 0,
      campaign: {},
      influencerId: '',
      isDealInProgressForCampaign: false,
      dealCheckComplete: false,
      loadingDealData: false,
      loadingUserData: false,
      previousDealLength: 0
    };

    this.state = {
      ...this.initialState
    };
  }

  componentWillMount() {
    const influencerId = this.props.auth.uid;
    this.setState({
      influencerId
    });

    const campaignId = this.props.match.params.id;
    this.props.firestore
      .get({
        collection: 'campaigns',
        storeAs: 'campaignDetails',
        doc: campaignId
      })
      .then(campaignSnapshot => {
        if (!campaignSnapshot || !campaignSnapshot.data()) {
          this.setState({
            campaignNotFound: true
          });
        } else {
          const campaign = campaignSnapshot.data();

          // if the user is a company and they did not create the campaign then redirect to dashboard
          if (
            this.props.profile.isCompany &&
            campaign.creator !== this.props.auth.uid
          ) {
            this.props.history.push('/dashboard');
          }

          this.props.firestore
            .get({
              collection: 'users',
              doc: campaign.creator
            })
            .then(user => {
              if (user && campaign.creator) {
                const userData = user.data();
                if (userData) {
                  campaign.companyName = userData.displayName;
                  campaign.picUrl = userData.profilePictureUrl;
                  campaign.companyId = user.id;
                  campaign.country = getCountryValueFromKey(campaign.country);
                  campaign.company = { ...userData, id: user.id };
                }
              }
              this.setState({
                campaign: {
                  ...campaign,
                  id: campaignSnapshot.id
                }
                // allProposals: this.props.allProposals
              });

              // check if deal already exists between the two parties on this campaign
              this.checkIfCurrentDealExists(
                campaignSnapshot.id,
                this.state.influencerId,
                user.id
              );
            });
        }
      })
      .catch(e => {
        this.setState({
          campaignNotFound: true
        });
      });
    this.loadProposalData(this.props.allProposals);
    this.loadDealData(this.props.allActiveandOrFutherDeals);
  }

  componentWillReceiveProps(nextProps) {
    if (
      (nextProps.allProposals &&
        nextProps.allProposals.length &&
        !this.state.loadingUserData) ||
      (this.props.allProposals.length &&
        !this.state.loadingUserData &&
        (!nextProps.allProposals || !nextProps.allProposals.length))
    ) {
      this.loadProposalData(nextProps.allProposals);
    }
    if (
      (nextProps.allActiveandOrFutherDeals &&
        nextProps.allActiveandOrFutherDeals.length &&
        !this.state.loadingDealData) ||
      (this.props.allActiveandOrFutherDeals.length &&
        !this.state.loadingDealData &&
        (!nextProps.allActiveandOrFutherDeals ||
          !nextProps.allActiveandOrFutherDeals.length))
      //       &&
      // this.state.previousDealLength !=
      //   nextProps.allActiveandOrFutherDeals.length
    ) {
      this.loadDealData(nextProps.allActiveandOrFutherDeals);
    }
  }

  loadProposalData(allProposals) {
    this.setState({
      loadingUserData: true
    });
    const requests = this.loadData(allProposals);

    Promise.all(requests).then(deals => {
      this.setState({
        allProposedDeals: deals,
        shortlisted: deals.filter(deal => deal.isShortlisted),
        messaged: deals.filter(deal => deal.hasBeenMessaged),
        pendingEscrow: deals.filter(
          deal => deal.status === dealStatuses.DEAL_ACCEPTED
        ),
        loadingUserData: false
      });
    });
  }

  loadDealData(allDeals) {
    this.setState({
      loadingDealData: true,
      previousDealLength: allDeals.length
    });
    const requests = this.loadData(allDeals);

    Promise.all(requests).then(deals => {
      this.setState({
        deals,
        activeDeals: deals.filter(deal => deal.status === dealStatuses.ACTIVE),
        contentCompleteDeals: deals.filter(
          deal => deal.status === dealStatuses.CONTENT_COMPLETE
        ),
        completeDeals: deals.filter(
          deal => deal.status === dealStatuses.COMPLETE
        ),
        loadingDealData: false
      });
    });
  }

  loadData(allProposals) {
    return allProposals.map(deal => {
      return new Promise(resolve => {
        // get user data
        this.props.firestore
          .get({
            collection: 'users',
            doc: deal.influencerId
          })
          .then(user => {
            if (user.exists) {
              const userData = user.data();
              if (userData) {
                deal.user = userData;
                deal.user.uid = user.id;
                deal.user.id = user.id;
              }
            }
            resolve({ ...deal, campaign: this.state.campaign });
          });
      });
    });
  }

  checkIfCurrentDealExists(campaignId, influencerId, companyId) {
    this.props.firestore
      .collection('deals')
      .where('influencerId', '==', influencerId)
      .where('campaignId', '==', campaignId)
      .where('companyId', '==', companyId)
      .get()
      .then(dealSnapshot => {
        if (dealSnapshot.docs.length) {
          const dealsInProgress = dealSnapshot.docs.filter(
            dealDoc => dealDoc.data().status != dealStatuses.COMPLETE
          );
          this.setState({
            isDealInProgressForCampaign: dealsInProgress.length > 0
          });
        }
        this.setState({
          dealCheckComplete: true
        });
      })
      .catch(e => {
        this.setState({
          dealCheckComplete: true
        });
      });
  }

  handleBackClick() {
    this.props.history.push(`/discover`);
  }

  navigateToCampaignList() {
    this.props.history.push(`/discover`);
  }

  navigateToCampaignAnalytics(campaignId) {
    this.props.history.push(`/campaigns/${campaignId}/analytics`);
  }

  handleChange = (event, newValue) => {
    this.setState({
      value: newValue,
      index: newValue
    });
  };

  handleInfluencerIndexChange = (event, newValue) => {
    this.setState({
      influencerViewIndex: newValue
    });
  };

  isReviewProposalsCurrentPage = page => {
    if (page === 3 || page === 4 || page === 5 || page === 6) {
      return true;
    }
    return false;
  };

  isDealsCurrentPage = page => {
    if (page === 7 || page === 8 || page === 9) {
      return true;
    }
    return false;
  };

  handleBackClick() {
    const newIndex = this.state.index - 1;
    this.setState({
      index: newIndex
    });
  }

  handleBackToListClick() {
    this.setState({
      index: 0
    });
  }

  proposeDealFromInfluencerClick = () => {
    this.setState({
      dealRecipient: this.state.campaign.company,
      campaign: this.state.campaign,
      index: 1
    });
  };

  onProposalComplete = () => {
    this.setState({
      isDealInProgressForCampaign: true
    });
    this.handleBackToListClick();
  };

  getInfluencerStepContent(params) {
    const { key } = params;
    switch (this.state.index) {
      case 0:
        return (
          <React.Fragment>
            <Typography
              variant="h6"
              onClick={() => this.navigateToCampaignList()}
              className={this.props.classes.backButton}
            >
              <ArrowBackIcon className={this.props.classes.backArrow} />
              Back to Search Results
            </Typography>
            <CampaignDetails
              campaign={this.state.campaign}
              dealCheckComplete={this.state.dealCheckComplete}
              isDealInProgressForCampaign={
                this.state.isDealInProgressForCampaign
              }
              existingDeals={this.state.existingDeals}
              proposeDealClickHandler={this.proposeDealFromInfluencerClick.bind(
                this
              )}
            />
          </React.Fragment>
        );
      case 1:
        return (
          <DealForm
            key={key}
            handleBackClick={this.handleBackClick.bind(this)}
            handleBackToListClick={this.handleBackToListClick.bind(this)}
            user={this.props.auth}
            onProposalComplete={this.onProposalComplete}
            dealRecipient={this.state.dealRecipient}
            campaign={this.state.campaign}
          />
        );
    }
  }

  render() {
    const { classes, profile, key, page, allProposals } = this.props;
    const {
      campaignNotFound,
      campaign,
      allProposedDeals,
      shortlisted,
      messaged,
      pendingEscrow,
      activeDeals,
      contentCompleteDeals,
      completeDeals,
      deals,
      influencerViewIndex
    } = this.state;

    return (
      <React.Fragment>
        <main className={classes.layout}>
          {profile.isCompany && (
            <React.Fragment>
              {campaignNotFound && (
                <Paper className={classes.root}>
                  <Typography variant="h3" alignCenter>
                    Campaign Not Found
                  </Typography>
                </Paper>
              )}
              {!campaignNotFound && (
                <main className={classes.layout}>
                  <div className={classes.paper}>
                    <div className={classes.pageTitle}>
                      <Typography
                        variant="h5"
                        className={classes.backButton}
                        display="inline"
                      >
                        {campaign.name}
                      </Typography>
                      <div className={classes.analyticsContainer}>
                        <Button
                          className={classes.analyticsButton}
                          onClick={() =>
                            this.navigateToCampaignAnalytics(campaign.id)
                          }
                        >
                          Campaign Analytics
                        </Button>
                      </div>
                    </div>
                    <CampaignNavBar
                      page={page}
                      campaignId={campaign.id}
                      allProposals={allProposedDeals}
                      deals={deals}
                    />
                    {page === 1 && (
                      <CampaignDetails
                        campaign={campaign}
                        dealCheckComplete={this.state.dealCheckComplete}
                        isDealInProgressForCampaign={
                          this.state.isDealInProgressForCampaign
                        }
                      />
                    )}
                    {page === 2 && <DiscoverInfluencers campaign={campaign} />}
                    {this.isReviewProposalsCurrentPage(page) && (
                      // allProposals &&
                      <ReviewProposals
                        campaign={campaign}
                        page={page}
                        allProposals={allProposedDeals}
                        shortlisted={shortlisted}
                        messaged={messaged}
                        pendingEscrow={pendingEscrow}
                      />
                    )}
                    {this.isDealsCurrentPage(page) && deals && (
                      <CampaignDeals
                        campaign={campaign}
                        page={page}
                        deals={deals}
                        activeDeals={activeDeals}
                        contentCompleteDeals={contentCompleteDeals}
                        completeDeals={completeDeals}
                      />
                    )}
                  </div>
                </main>
              )}
            </React.Fragment>
          )}
          {!profile.isCompany && (
            <React.Fragment>
              <VirtualizeSwipeableViews
                style={{ width: '100%' }}
                slideCount={2}
                index={this.state.influencerViewIndex}
                slideRenderer={this.getInfluencerStepContent.bind(this)}
                disabled={true}
              />
            </React.Fragment>
          )}
        </main>
      </React.Fragment>
    );
  }
}

export default enhance(Campaign);



// WEBPACK FOOTER //
// ./src/components/campaign/Campaign.js